/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminClassDayDetailDTO,
  AdminClassDayGetAdminClassDaysForOrganizationParams,
  AdminClassDayGetAdminClassDaysForSemesterParams,
  AdminClassDayListItemDTOQueryResultDTO,
  UpsertAdminClassDayDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminClassDayGetAdminClassDayDetail = (
    organizationId: number,
    classDayId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassDayDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClassDay/${classDayId}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminClassDayGetAdminClassDayDetailQueryKey = (organizationId: number,
    classDayId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClassDay/${classDayId}`] as const;
    }

    
export const getAdminClassDayGetAdminClassDayDetailQueryOptions = <TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError = ErrorType<unknown>>(organizationId: number,
    classDayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassDayGetAdminClassDayDetailQueryKey(organizationId,classDayId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>> = ({ signal }) => adminClassDayGetAdminClassDayDetail(organizationId,classDayId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && classDayId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassDayGetAdminClassDayDetailQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>>
export type AdminClassDayGetAdminClassDayDetailQueryError = ErrorType<unknown>


export function useAdminClassDayGetAdminClassDayDetail<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classDayId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>,
          TError,
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassDayGetAdminClassDayDetail<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classDayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>,
          TError,
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassDayGetAdminClassDayDetail<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classDayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassDayGetAdminClassDayDetail<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classDayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDayDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassDayGetAdminClassDayDetailQueryOptions(organizationId,classDayId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminClassDayUpdateClassDay = (
    organizationId: number,
    classDayId: number,
    upsertAdminClassDayDTO: UpsertAdminClassDayDTO,
 ) => {
      
      
      return customInstance<AdminClassDayDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClassDay/${classDayId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminClassDayDTO
    },
      );
    }
  


export const getAdminClassDayUpdateClassDayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDayUpdateClassDay>>, TError,{organizationId: number;classDayId: number;data: UpsertAdminClassDayDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassDayUpdateClassDay>>, TError,{organizationId: number;classDayId: number;data: UpsertAdminClassDayDTO}, TContext> => {
    
const mutationKey = ['adminClassDayUpdateClassDay'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassDayUpdateClassDay>>, {organizationId: number;classDayId: number;data: UpsertAdminClassDayDTO}> = (props) => {
          const {organizationId,classDayId,data} = props ?? {};

          return  adminClassDayUpdateClassDay(organizationId,classDayId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassDayUpdateClassDayMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassDayUpdateClassDay>>>
    export type AdminClassDayUpdateClassDayMutationBody = UpsertAdminClassDayDTO
    export type AdminClassDayUpdateClassDayMutationError = ErrorType<unknown>

    export const useAdminClassDayUpdateClassDay = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDayUpdateClassDay>>, TError,{organizationId: number;classDayId: number;data: UpsertAdminClassDayDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassDayUpdateClassDay>>,
        TError,
        {organizationId: number;classDayId: number;data: UpsertAdminClassDayDTO},
        TContext
      > => {

      const mutationOptions = getAdminClassDayUpdateClassDayMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassDayDeleteClassDay = (
    organizationId: number,
    classDayId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminClassDay/${classDayId}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminClassDayDeleteClassDayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDayDeleteClassDay>>, TError,{organizationId: number;classDayId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassDayDeleteClassDay>>, TError,{organizationId: number;classDayId: number}, TContext> => {
    
const mutationKey = ['adminClassDayDeleteClassDay'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassDayDeleteClassDay>>, {organizationId: number;classDayId: number}> = (props) => {
          const {organizationId,classDayId} = props ?? {};

          return  adminClassDayDeleteClassDay(organizationId,classDayId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassDayDeleteClassDayMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassDayDeleteClassDay>>>
    
    export type AdminClassDayDeleteClassDayMutationError = ErrorType<unknown>

    export const useAdminClassDayDeleteClassDay = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDayDeleteClassDay>>, TError,{organizationId: number;classDayId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassDayDeleteClassDay>>,
        TError,
        {organizationId: number;classDayId: number},
        TContext
      > => {

      const mutationOptions = getAdminClassDayDeleteClassDayMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassDayGetAdminClassDaysForOrganization = (
    organizationId: number,
    params?: AdminClassDayGetAdminClassDaysForOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassDayListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClassDay`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminClassDayGetAdminClassDaysForOrganizationQueryKey = (organizationId: number,
    params?: AdminClassDayGetAdminClassDaysForOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClassDay`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminClassDayGetAdminClassDaysForOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminClassDayGetAdminClassDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassDayGetAdminClassDaysForOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>> = ({ signal }) => adminClassDayGetAdminClassDaysForOrganization(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassDayGetAdminClassDaysForOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>>
export type AdminClassDayGetAdminClassDaysForOrganizationQueryError = ErrorType<unknown>


export function useAdminClassDayGetAdminClassDaysForOrganization<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminClassDayGetAdminClassDaysForOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassDayGetAdminClassDaysForOrganization<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminClassDayGetAdminClassDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassDayGetAdminClassDaysForOrganization<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminClassDayGetAdminClassDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassDayGetAdminClassDaysForOrganization<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminClassDayGetAdminClassDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassDayGetAdminClassDaysForOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminClassDayCreateClassDay = (
    organizationId: number,
    upsertAdminClassDayDTO: UpsertAdminClassDayDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassDayDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClassDay`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminClassDayDTO, signal
    },
      );
    }
  


export const getAdminClassDayCreateClassDayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDayCreateClassDay>>, TError,{organizationId: number;data: UpsertAdminClassDayDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassDayCreateClassDay>>, TError,{organizationId: number;data: UpsertAdminClassDayDTO}, TContext> => {
    
const mutationKey = ['adminClassDayCreateClassDay'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassDayCreateClassDay>>, {organizationId: number;data: UpsertAdminClassDayDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminClassDayCreateClassDay(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassDayCreateClassDayMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassDayCreateClassDay>>>
    export type AdminClassDayCreateClassDayMutationBody = UpsertAdminClassDayDTO
    export type AdminClassDayCreateClassDayMutationError = ErrorType<unknown>

    export const useAdminClassDayCreateClassDay = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDayCreateClassDay>>, TError,{organizationId: number;data: UpsertAdminClassDayDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassDayCreateClassDay>>,
        TError,
        {organizationId: number;data: UpsertAdminClassDayDTO},
        TContext
      > => {

      const mutationOptions = getAdminClassDayCreateClassDayMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassDayGetAdminClassDaysForSemester = (
    organizationId: number,
    semesterId: number,
    params?: AdminClassDayGetAdminClassDaysForSemesterParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassDayListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClassDay/semester/${semesterId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminClassDayGetAdminClassDaysForSemesterQueryKey = (organizationId: number,
    semesterId: number,
    params?: AdminClassDayGetAdminClassDaysForSemesterParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClassDay/semester/${semesterId}`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminClassDayGetAdminClassDaysForSemesterQueryOptions = <TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError = ErrorType<unknown>>(organizationId: number,
    semesterId: number,
    params?: AdminClassDayGetAdminClassDaysForSemesterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassDayGetAdminClassDaysForSemesterQueryKey(organizationId,semesterId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>> = ({ signal }) => adminClassDayGetAdminClassDaysForSemester(organizationId,semesterId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && semesterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassDayGetAdminClassDaysForSemesterQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>>
export type AdminClassDayGetAdminClassDaysForSemesterQueryError = ErrorType<unknown>


export function useAdminClassDayGetAdminClassDaysForSemester<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params: undefined |  AdminClassDayGetAdminClassDaysForSemesterParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>,
          TError,
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassDayGetAdminClassDaysForSemester<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params?: AdminClassDayGetAdminClassDaysForSemesterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>,
          TError,
          Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassDayGetAdminClassDaysForSemester<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params?: AdminClassDayGetAdminClassDaysForSemesterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassDayGetAdminClassDaysForSemester<TData = Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params?: AdminClassDayGetAdminClassDaysForSemesterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassDayGetAdminClassDaysForSemester>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassDayGetAdminClassDaysForSemesterQueryOptions(organizationId,semesterId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



